export interface MapCoordinate {
  holeId: string
  latitude: number
  longitude: number
  type: 'tee' | 'green' | 'hazard'
  teeType?: string
}

export const yardsBetween = (a: MapCoordinate, b: MapCoordinate) => {
  const radians = (value: number) => value * Math.PI / 180
  const dLat = radians(b.latitude - a.latitude)
  const dLng = radians(b.longitude - a.longitude)
  const value = Math.sin(dLat / 2) ** 2
    + Math.cos(radians(a.latitude)) * Math.cos(radians(b.latitude)) * Math.sin(dLng / 2) ** 2
  return Math.round(6371000 * 2 * Math.atan2(Math.sqrt(value), Math.sqrt(1 - value)) * 1.09361)
}

export const displayDistanceFromYards = (yards: number, unit: 'yards' | 'metres') =>
  unit === 'metres' ? Math.round(yards / 1.09361) : Math.round(yards)

export const upsertMapCoordinate = <T extends MapCoordinate>(coordinates: T[], next: T): T[] => {
  if (next.type === 'hazard') return [...coordinates, next]
  const index = coordinates.findIndex(item =>
    item.holeId === next.holeId && item.type === next.type
    && (next.type === 'green' || item.teeType === next.teeType))
  return index < 0 ? [...coordinates, next] : coordinates.map((item, itemIndex) => itemIndex === index ? next : item)
}

export interface MapCoverage {
  totalHoles: number
  greenDistanceHoles: number
  confirmedPolygonHoles: number
  manualGreenHoles: number
  teeLocationHoles: number
  hazardLocationHoles: number
}

export const calculateMapCoverage = (
  holeIds: string[], coordinates: MapCoordinate[], confirmedGreenHoleIds: Iterable<string>,
): MapCoverage => {
  const valid = new Set(holeIds), polygons = new Set([...confirmedGreenHoleIds].filter(id => valid.has(id)))
  const manualGreens = new Set(coordinates.filter(c => valid.has(c.holeId) && c.type === 'green').map(c => c.holeId))
  const tees = new Set(coordinates.filter(c => valid.has(c.holeId) && c.type === 'tee').map(c => c.holeId))
  const hazards = new Set(coordinates.filter(c => valid.has(c.holeId) && c.type === 'hazard').map(c => c.holeId))
  return { totalHoles: holeIds.length, confirmedPolygonHoles: polygons.size, manualGreenHoles: manualGreens.size,
    greenDistanceHoles: new Set([...polygons, ...manualGreens]).size, teeLocationHoles: tees.size, hazardLocationHoles: hazards.size }
}
